import React, { useEffect, useRef, useState } from "react";
import TreeView from "@mui/lab/TreeView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TreeItem from "@mui/lab/TreeItem";
import {
  Grid,
  Button,
  Box,
  Stack,
  TextField,
  Typography,
  Skeleton,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import ItemMenu from "./ItemMenu";
import FolderIcon from "@mui/icons-material/Folder";
import RenamingTreeItem from "./RenamingTreeItem";
import { getData } from "src/apis/controllers/apiEntities";
import DynamicDialog from "src/qubCommon/Dialogs/DynamicDialog";
import { Can } from "context/permissionContenxt";

const FolderStructure = ({ panel, explorerDataKey, treeItems }) => {
  const [itemAnchorEl, setItemAnchorEl] = React.useState(null);
  const [selectedItem, setSelectedItem] = useState(treeItems?.[0]?.Id || null);
  const [renamingItem, setRenamingItem] = useState(null);
  const [viewedItem, setViewedItem] = useState(null);
  const [isFolder, setIsFolder] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);

  const inputRef = useRef();

  // async function getTreeItems() {
  //   const res = await getData({
  //     dataKey: "Stats-Get-Folders",
  //     parameters: { ExplorerDataKey: explorerDataKey },
  //   });
  //   setTreeItems(res?.data);
  // }

  // useEffect(() => {
  //   getTreeItems();
  // }, []);

  useEffect(() => {
    if (selectedItem) {
      setViewedItem(selectedItem);
      panel.viewDefinition = JSON.stringify(
        treeItems?.find((item) => item.Id === selectedItem)?.ViewDefinition ||
          ""
      );
    }
  }, []);

  const handleClickItem = (viewDefinition, id) => {
    setViewedItem(id);
    try {
      panel.viewDefinition = JSON.stringify(viewDefinition);
    } catch (e) {
      console.log("error", e);
    }
  };

  const handleRightClickItem = (e, item) => {
    e.preventDefault();
    setItemAnchorEl(e.currentTarget);
    if (item?.isFolder) {
      setIsFolder(true);
    }
    setSelectedItem(item?.Id);
  };

  const handleClose = () => {
    setItemAnchorEl(null);
    setIsFolder(false);
  };

  const setTextInputRef = (element) => {
    inputRef.current = element;
  };

  const handleRename = () => {
    setRenamingItem(selectedItem);
    setSelectedItem(null);
    setItemAnchorEl(null);
  };

  const handleForceDelete = async () => {
    try {
      const res = await getData({
        dataKey: "Stats-Delete-Folders",
        parameters: { TreeItem: selectedItem, ForceSave: 1 },
      });
      await getTreeItems();
      handleClose();
      if (res?.status?.toLowerCase() === "success")
        setDeleteDialog({
          open: true,
          type: res?.status,
          onClose: () => setDeleteDialog((prev) => ({ ...prev, open: false })),
          onAccept: () => {
            setDeleteDialog((prev) => ({ ...prev, open: false }));
          },
          hideSecondaryButton: true,
          meta: {
            action: "Ok",
            cancel: false,
            title: "Διαγραφή",
            description: res.message,
          },
        });
    } catch (e) {
      console.log("error", e);
    }
  };

  const handleDelete = async (forceSave = 0) => {
    console.log(selectedItem, isFolder);

    try {
      const res = await getData({
        dataKey: "Stats-Delete-Folders",
        parameters: { TreeItem: selectedItem, ForceSave: 0 },
      });
      if (res?.status?.toLowerCase() === "warning")
        setDeleteDialog({
          open: true,
          type: "warning",
          onClose: () => {
            handleClose();
            setDeleteDialog((prev) => ({ ...prev, open: false }));
          },
          onAccept: () => handleForceDelete(),
          hideSecondaryButton: res?.status !== "warning",
          meta: {
            action: res?.status === "warning" ? "Yes" : "No",
            cancel: res?.status === "warning" ? "No" : false,
            title: "Διαγραφή",
            description: res.message,
          },
        });
    } catch (e) {
      console.log("error", e);
    }
  };

  const handleTextFieldKeyDown = (item) => async (ev) => {
    if (ev.key === "Enter") {
      try {
        const res = await getData({
          dataKey: "Stats-Rename-Folders",
          parameters: { TreeItem: item?.Id, ItemDescription: ev.target.value },
        });
        await getTreeItems();
      } catch (e) {
        console.log("error", e);
      }
      setRenamingItem(null);
    }
  };

  const handleRenameOnBlur = (ev) => {
    setRenamingItem(null);
  };

  React.useEffect(() => {
    if (renamingItem) {
      inputRef.current.focus();
    }
  }, [renamingItem]);

  const handleNewItem = async () => {
    try {
      const res = await getData({
        dataKey: "Stats-New-Folders",
        parameters: {
          ParentId: selectedItem,
          ExplorerDatakey: explorerDataKey,
          isFolder: 0,
        },
      });
      await getTreeItems();
      handleClose();
    } catch (e) {
      console.log("error new folder", e);
      handleClose();
    }
  };

  if (treeItems?.length > 0)
    return (
      <>
        <DynamicDialog {...deleteDialog} />
        <ItemMenu
          anchorEl={itemAnchorEl}
          handleClose={handleClose}
          handleRename={handleRename}
          newItem={isFolder}
          handleNewItem={handleNewItem}
          handleDelete={handleDelete}
        />
        {/* <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
        > */}
        <Can I="View" a="GovnrApplications" passThrough>
          {(allowed) => (
            <>
              {treeItems?.length > 0 &&
                treeItems?.map((item) => {
                  const isSelected = item.Id === viewedItem;

                  return (
                    <MenuItem
                      onClick={() =>
                        handleClickItem(item.ViewDefinition, item.Id)
                      }
                      key={item.Id}
                      sx={{
                        backgroundColor: isSelected
                          ? "primary.light"
                          : "transparent",
                        color: isSelected ? "primary.contrastText" : "inherit",
                        borderRadius: 1,
                        "&:hover": {
                          backgroundColor: "action.hover",
                        },
                      }}
                    >
                      <ListItemIcon>
                        <StackedLineChartIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>{item.Description}</ListItemText>
                      {/* <Button onClick={() => console.log(panel.viewDefinition)}>
                        Save
                      </Button> */}
                    </MenuItem>
                  );
                })}
            </>
          )}
        </Can>
        {/* </Box> */}
      </>
    );
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        {/* <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={async () => {
                try {
                  const res = await getData({
                    dataKey: "Stats-New-Folders",
                    parameters: {
                      ExplorerDatakey: explorerDataKey,
                      isFolder: 1,
                    },
                  });
                  await getTreeItems();
                } catch (e) {
                  console.log("error new folder", e);
                }
              }}
            >
              New Folder
            </Button>
            <Button
              onClick={async () => {
                const selectedItem = treeItems.find(
                  (treeItem) => treeItem.Id === viewedItem
                );
                if (!selectedItem?.isFolder) {
                  const res = await getData({
                    dataKey: "Stats-Save-Folders",
                    parameters: {
                      ItemId: viewedItem,
                      ViewDefinition: panel.viewDefinition,
                    },
                  });
                }
                await getTreeItems();
              }}
            >
              Save
            </Button>
          </Box>
          <Stack direction="column">
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
          </Stack>
        </Box> */}
      </Box>
    </>
  );
};

export default FolderStructure;
